export const INITIAL_MESSAGE = {
    role: "assistant",
    content: "Hello! Good day, what kind of property are you looking for today?"
};